// Local module to retrieve the window.location object, primarily to allow
// for mocking it in tests.
const windowLocation = () => window.location;

export default windowLocation;
